var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/bagProductPage.4acd50f1.png","uri@2x": __webpack_public_path__ + "static/media/bagProductPage.bc77a797.png","uri@3x": __webpack_public_path__ + "static/media/bagProductPage.4199e781.png",
    width: 24,
    height: 24
});